import { StyleSheet } from 'react-native';
import {
  fontFamilyMedium,
  fontSizeSmall,
  grey,
  fontFamilyLight,
  fontSizeExtraSmall,
  fontSizeMicro,
  italic,
} from '../../../constants/palette';

export default StyleSheet.create({
  container: {
    marginBottom: 10,
  },
  radioButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 10,
    paddingBottom: 10,
  },
  radioGroup: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  text: {
    fontFamily: fontFamilyMedium,
    fontSize: fontSizeSmall,
  },
  disabledText: {
    color: grey,
    fontFamily: fontFamilyMedium,
    fontSize: fontSizeSmall,
  },
  subText: {
    color: grey,
    fontFamily: fontFamilyLight,
    fontSize: fontSizeExtraSmall,
    fontStyle: italic,
  },
  subTextSpotify: {
    color: grey,
    fontFamily: fontFamilyLight,
    fontSize: fontSizeMicro,
    fontStyle: italic,
  },
  textSelectionWrapper: { justifyContent: 'center', flexDirection: 'column' },
});
